import { render, staticRenderFns } from "./lateReason.vue?vue&type=template&id=642c45d2"
import script from "./lateReason.vue?vue&type=script&lang=js"
export * from "./lateReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports